<template>
    <div>

        <GmapAutocomplete :value="description" placeholder="Ingresa tu busqueda" @place_changed="setPlace"
            :select-first-on-enter="true" id="vuetify-google-autocomplete-id">
        </GmapAutocomplete>

        <GmapMap :center="center" :zoom="zoom" style="width: 100%; height: 500px">
            <GmapMarker :key="index" v-for="(marker, index) in markers" :position="marker.position" :clickable="true"
                :draggable="true" @click="center = marker.position" />
        </GmapMap>

        <!-- <GmapStreetViewPanorama :position="streetViewPosition" style="width: 100%; height: 300px; margin-top: 20px"
            ref="streetView" /> -->
    </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'

export default {

    computed: {
        google: gmapApi
    },

    data() {
        return {
            zoom: 12,
            description: "",
            center: { lat: -12.04318, lng: -77.02824 },
            markers: [
                { position: { lat: -12.04318, lng: -77.02824 } },
            ],
            streetViewPosition: { lat: -12.04318, lng: -77.02824 },
        }
    },


    methods: {
        setDescription(description) {
            this.description = description;
        },

        setPlace(place) {
            if (!place) return
            this.zoom = 14;
            this.center = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };

            this.markers = [
                { position: { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() } }, // Marcador inicial
            ];

        },

        updateStreetView(event) {
            const newPosition = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
            };
            this.streetViewPosition = newPosition;
        },

    },

}

// export default {
//     name: 'GoogleChart',
//     components: {
//         GChart,
//     },

//     beforeMount() {
//         this.$store.dispatch("findEmployessByLocation").then((res) => {
//             res.forEach(element => {
//                 let item = [element.name, element.employees];
//                 this.chartData.push(item);
//             });
//         })
//     },

//     data() {
//         return {
//             type: chartType,
//             chartData: [['Province', 'Empleados'],],
//             options: chartOptions,
//             settings: {
//                 packages: ['geochart', 'map'],
//             },
//             chartEvents: {
//                 'regionClick': (value) => {
//                     this.loadInfo(value);
//                 },
//             }
//         };
//     },

//     methods: {
//         loadInfo(value) {
//             console.log(value);
//         },
//     },

// };
</script>


<style global>
#vuetify-google-autocomplete-id {
    border-style: solid;
    width: 100%;
    height: 20px;
    margin-bottom: 5px;
    ;
}
</style>